import { render, staticRenderFns } from "./workCamp.vue?vue&type=template&id=97d9c4da&"
import script from "./workCamp.vue?vue&type=script&lang=js&"
export * from "./workCamp.vue?vue&type=script&lang=js&"
import style0 from "./workCamp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports